<section>
  <div id="clientDetails" *ngIf="!hideAddress" class="contract-summary-layout">
    <mat-card class="contract-summary-card">
      <mat-card-header>
        <mat-card-title>Contract Summary</mat-card-title>
      </mat-card-header>
      <mat-card-content class="material-form-grid">
        <div>
          <strong>Contract Code</strong>:
          <span id="contractcode">{{ contract?.uuid }}</span>
        </div>
        <div>
          <strong>Maintenance Start</strong>:
          <span id="start">{{ contract?.startDate | date: "dd MMMM yyyy" }}</span>
        </div>
        <div>
          <strong>Maintenance End</strong>:
          <span id="end">{{ contract?.endDate | date: "dd MMMM yyyy" }}</span>
        </div>
        <div>
          <strong>Product</strong>:
          <span id="product">{{ contract?.displayName }}</span>
        </div>
        <div *ngIf="showReturns">
          <strong>Surrenders Remaining</strong>:
          <span id="returns">{{ contract?.returnsRemaining }}</span>
        </div>
        <div>
          <strong>Rental</strong>:
          <span id="rental">{{ contract?.rental ? 'Yes' : 'No' }}</span>
        </div>
        <div *ngIf="contract?.siteEnabled">
          <strong>Site Licensed</strong>:
          <span id="siteLicensed">{{ contract?.siteEnabled ? 'Yes' : 'No' }}</span>
        </div>
        <div *ngIf="contract?.siteEnabled">
          <strong>Site Licences Available</strong>:
          <span id="siteLicences">{{ contract?.siteLicences }}</span>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card class="customer-summary-card" *ngIf="showCustomerInfo">
      <mat-card-header>
        <mat-card-title>Customer Info</mat-card-title>
      </mat-card-header>
      <mat-card-content *ngIf="!loadingCustomerInfo; else loadingCustomerInfoTemplate">
        <div class="material-form-grid" *ngIf="customerInfo">
          <div class="full-width">
            <strong>Customer Name</strong>:
            <span id="CustomerName">{{ customerInfo.company }}</span>
          </div>
          <div class="full-width">
            <strong>Address</strong>:
            <span id="Address">
              <span *ngIf="customerInfo.address1 != null">{{ customerInfo.address1 }}, </span>
              <span *ngIf="customerInfo.address2 != null && customerInfo.address2 != ''">{{ customerInfo.address2 }}, </span>
              <span *ngIf="customerInfo.address3 != null && customerInfo.address3 != ''">{{ customerInfo.address3 }}, </span>
              <span *ngIf="customerInfo.address4 != null && customerInfo.address4 != ''">{{ customerInfo.address4 }}, </span>
              {{ customerInfo.city }}, {{ customerInfo.zip }}, {{ customerInfo.country }}
            </span>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</section>

<ng-template #loadingCustomerInfoTemplate>
  <div class="page-loading-spinner">
    <mat-spinner diameter="40"></mat-spinner>
    <p><strong>Loading customer info...</strong></p>
  </div>
</ng-template>
